import { render } from "./IconCog.vue?vue&type=template&id=16ef7016"
import script from "./IconCog.vue?vue&type=script&lang=js"
export * from "./IconCog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__